/**
 * Auth Page - OIDC Login Redirect
 */
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '@shared/auth';
import { getBrandName } from '@shared/config/brand';
import { BarChart3 } from 'lucide-react';

const AuthPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { login, isAuthenticated, isLoading } = useAuth();

  // Honor the URL preserved by ProtectedRoute (state.from) so deep-links
  // survive an OIDC round-trip instead of dropping users on /dashboard.
  const fromLoc = location.state?.from;
  const returnUrl = fromLoc?.pathname
    ? `${fromLoc.pathname}${fromLoc.search || ''}`
    : '/dashboard';

  useEffect(() => {
    if (!isLoading && isAuthenticated) {
      navigate(returnUrl, { replace: true });
      return;
    }
    if (!isLoading && !isAuthenticated) {
      login(returnUrl);
    }
  }, [isLoading, isAuthenticated, login, navigate, returnUrl]);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="text-center">
        <div className="h-16 w-16 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <BarChart3 size={32} className="text-primary-600" />
        </div>
        <h1 className="text-xl font-bold text-gray-900 mb-2">{getBrandName()} Analytics</h1>
        <p className="text-sm text-gray-500 mb-6">Redirecting to sign in...</p>
        <div className="flex justify-center">
          <div className="animate-spin h-6 w-6 border-2 border-primary-600 border-t-transparent rounded-full"></div>
        </div>
      </div>
    </div>
  );
};

export default AuthPage;
